"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("../base/config");
var debug_1 = require("./debug");
function globalHandleError(errMsg, app) {
    if (errMsg === void 0) { errMsg = ''; }
    if (typeof config_1.default.errorHandler === 'function') {
        config_1.default.errorHandler.call(this, new Error(errMsg), app);
    }
    else {
        debug_1.errorer(errMsg);
    }
}
exports.globalHandleError = globalHandleError;
